<div class="vertical-container-simple clickable">
  <div data-qa="show-data-behind-table"
    class="start-row-container row-gap-0p5 card"
    [class.no-bg]="show.table"
    (click)="show.table = !show.table">
    <app-table-group-icon
      [opened]="show.table">
    </app-table-group-icon>
    <div class="font-3 bold500">Data behind</div>
  </div>
  <div class="table-fms">
    <table *ngIf="show.table && data">
      <thead>
        <tr>
          <th class="width-2">  <app-three-dots-menu [matMenuTriggerFor]="menu"></app-three-dots-menu>
            <mat-menu #menu="matMenu">
              <ul class="list">
                <li class="table-menu-item" (click)="exportExcel()">
                  <app-all-icons [iconNameAndStyling]="'excel.svg'"></app-all-icons>
                  <span class="table-menu-text">Export</span>
                </li>
              </ul>
            </mat-menu></th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byName">
                {{categoryName}}
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byName">
                  {{categoryName}}
                </span>
              }
          </th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byCost">
                Investment
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byCost">
                  Investment
                </span>
              }
          </th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byFmv">
              Fair value
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byFmv">
                  Fair value
                </span>
             }
          </th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byGainLoss">
                Gain/(loss)
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byGainLoss">
                  Gain/(loss)
                </span>
              }
          </th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byMoic">
                MOIC
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byMoic">
                  MOIC
                </span>
              }
          </th>
          <th class="blank-space no-hover"></th>
          <th>
            @if (!isOnlyCompanies) {
              <span appSort
                [arr]="[data.body]"
                [keySelector]="sortDataBehindFvAndPP.byPcntTotalCost">
                % of Cost
              </span>
            } @else {
                <span appSort
                  [arr]="[data.body[0].drilldown]"
                  [keySelector]="dataBehindCompaniesSort.byPcntTotalCost">
                  % of Cost
                </span>
              }
          </th>
          <th>
            @if (!isOnlyCompanies) {
                <span appSort
                  [arr]="[data.body]"
                  [keySelector]="sortDataBehindFvAndPP.byPcntTotalFmv">
                  % of FV
                </span>
             } @else {
                  <span appSort
                    [arr]="[data.body[0].drilldown]"
                    [keySelector]="dataBehindCompaniesSort.byPcntTotalFmv">
                    % of FV
                  </span>
                }
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor=" let gropedBy of data.body; let i = index">
          <tr *ngIf="!isOnlyCompanies" [attr.data-qa]="'type-' + i" (click)="show.row[i] = !show.row[i]">
            <td>
              <app-table-group-icon [opened]="show.row[i]"></app-table-group-icon>
            </td>
            <td>
              <div class="start-row-container row-gap-0p5">
                <span>{{gropedBy.type.companyData.name}}</span>
                <app-circle-badge-count [count]="gropedBy.drilldown.length"></app-circle-badge-count>
              </div>
            </td>
            <td>{{gropedBy.type.cost | switcherDashBraces : numberSwitcher : 0}}</td>
            <td>{{gropedBy.type.fairValue | switcherDashBraces : numberSwitcher : 0}}</td>
            <td>{{gropedBy.type.gain | switcherDashBraces : numberSwitcher : 0}}</td>
            <td>{{gropedBy.type.moic | switcherDashBraces: 1 : 2: false : 'x'}}</td>
            <td class="blank-space no-hover"></td>
            <td>{{gropedBy.type.pcntOfTotalCost | switcherDashBraces: 1 : 2: false : '': '%'}}</td>
            <td>{{gropedBy.type.pcntOfTotalFmv | switcherDashBraces: 1 : 2: false : '': '%'}}</td>
          </tr>
          <ng-container *ngIf="show.row[i]">
            <tr *ngFor="let company of gropedBy.drilldown">
              <td></td>
              <td class="company-name" (click)="goToCompanyPage(company)">{{company.companyData.name}}</td>
              <td>{{company.cost | switcherDashBraces : numberSwitcher : 0}}</td>
              <td>{{company.fairValue | switcherDashBraces : numberSwitcher : 0}}</td>
              <td>{{company.gain | switcherDashBraces : numberSwitcher : 0}}</td>
              <td>{{company.moic | switcherDashBraces: 1 : 2: false : 'x'}}</td>
              <td class="blank-space no-hover"></td>
              <td>{{company.pcntOfTotalCost | switcherDashBraces: 1 : 2: false : '': '%'}}</td>
              <td>{{company.pcntOfTotalFmv | switcherDashBraces: 1 : 2: false : '' : '%'}}</td>
            </tr>
          </ng-container>
        </ng-container>
      </tbody>
      <tfoot>
        <tr class="total">
          <td></td>
          <td>Total</td>
          <td>{{data.total.cost | switcherDashBraces : numberSwitcher : 0}}</td>
          <td>{{data.total.fairValue | switcherDashBraces : numberSwitcher : 0}}</td>
          <td>{{data.total.gain | switcherDashBraces : numberSwitcher : 0}}</td>
          <td>{{data.total.moic | switcherDashBraces: 1 : 2: false : 'x'}}</td>
          <td class="blank-space no-hover"></td>
          <td>100%</td>
          <td>100%</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
